import { useAppContext } from "contexts/AppContext";
import { Navigate } from "react-router-dom";

const ContextRoute = ({ children, dependsOn }) => {
  const appContext = useAppContext();

  if (!!appContext[dependsOn]) {
    return children;
  }

  return <Navigate to="/unico" />;
};

export default ContextRoute;
